import { FeedbackDialogWrapper } from '@/features/client/components/feedback-dialog-wrapper'
import { SignContractPopup } from '@/features/client/components/sign-contract-popup'
import { ClientProvider } from '@/context/client'
import { PageLayout } from '@/layouts'
import { ClientPfIdentificationForm } from './client-pf-identification-form'
import { ClientRegistrationFlowPf } from './client-registration-flow-pf'

export default function ClienteConsultFormPf() {
  return (
    <ClientProvider>
      <ClientConsultFormContentPf />
    </ClientProvider>
  )
}

function ClientConsultFormContentPf() {
  return (
    <PageLayout title="Cadastrar PF">
      <ClientPfIdentificationForm />
      <ClientRegistrationFlowPf />
      <SignContractPopup />

      <FeedbackDialogWrapper />
    </PageLayout>
  )
}
